/**
 * Seed.Tab
 */

define(
        'Seed.Tab',['jquery', 'smartController', 'resizeScreen', 'requiredField', 'Seed', 'parameter'],
        function ($, smartVersion, resizeScreen, requiredField, Seed, parameter) {
            'use strict';

            Seed.Tab = {
                /**
                 * Nom du Module courant
                 */
                CurrentModule: 0,
                Module: 0,
                /**
                 * Onglet actuel
                 */
                cTab: 0,
                /**
                 * Compteur d'identifiant des onglets
                 */
                iTab: 0,
                aTab: [],
                /**
                 * Tableau des fonctions à lancer
                 */
                aCallback: [],
                /**
                 * Onglet parent d'un onglet
                 */
                aParent: [],
                /**
                 * Tableau d'onglet Children pour un Onglet
                 */
                aChild: [],
                /**
                 * Tableau des modules
                 */
                aModule: [],
                /**
                 * Identifiant de l'onglet actif par Module
                 */
                aActive: [],
                /**
                 * Ligne selectionnée et ouverte
                 */
                focusElementChildNumber: 0,
                /**
                 * To get in memory the opened panel
                 */
                aExpanded: [],
                aFocused: [],
                aOffset: [],
                aScroll: [],
                aOrder: [],
                // Set Offset to make a scollTo in non-SM form - based on scrollBar position
                SetElementPosition: function (selectedElement) {
                    var topOffset = $(document).scrollTop();
                    this.SetOffset(topOffset);
                },
                // Execute the scrollTo in non-SM form
                GoToPosition: function () {
                    var topOffset = this.GetOffset();
                    if (topOffset) {
                        window.scrollTo(0, topOffset);
                    }
                },
                // Method to set the offset in SM mode, depending on
                // which elem got focused
                SetElementChildNumber: function (
                        myPanel,
                        isFromForm,
                        specialTreatment,
                        inputRefresh,
                        isASignature
                        ) {
                    if (isFromForm) {
                        if (!specialTreatment) {
                            var childCounterFromForm = $(myPanel).parent().parent().index();
                            this.SetOffset(childCounterFromForm);
                        } else {
                          if(isASignature === true)
                            var childCounterFromForm =  $(myPanel).parent().parent().parent().index();
                          else
                            var childCounterFromForm =  $(myPanel).parent().parent().parent().parent().index();
                          if(inputRefresh === undefined)
                            this.SetOffset(childCounterFromForm - 1);
                          else
                            this.SetOffset(childCounterFromForm);
                        }
                    } else {
                        var childCounterFromList = $(myPanel).index();
                        if (specialTreatment) {
                            this.SetOffset(childCounterFromList - 1);
                        } else {
                            this.SetOffset(childCounterFromList + 1);
                        }
                    }

                },
                // Execute a scrollTo or go into the form in SM mode -if n is
                // even, scrollTo in list - if odd, return back into the form
                GetElementInFrame: function (n) {
                    if (((n & 1) === 0) && (n >= 0)) {
                        var n = n + 1;
                        var backId = Seed.Tab.GetFrame().find('#panel-group')
                                .children(':nth-child(' + n + ')').attr("id");
                        if (typeof backId !== 'undefined') {
                            var topOffset = $('#' + backId).offset().top;
                            var panelHeight = $('#' + backId).innerHeight();
                            var valueToScroll = topOffset - panelHeight; //Magic value ;)
                            window.scrollTo(0, valueToScroll);

                        }
                    } else if (((n & 1) === 1) && (n >= 0)) {
                        smartVersion.editPanel(n, true);
                    } else{
                        window.scrollTo(0, 0);
                    }
                },
                GetCurrentTab: function () {
                    if (typeof this.cTab === "undefined") {
                        var bug = true;
                        this.cTab = $('[id^=tab_]:visible');
                    }

                    return this.cTab;
                },
                GetCurrentTabID: function () {
                    return this.GetCurrentTab().attr("id");
                },
                /**
                 * Associer une fonction à un élément.
                 * @param pFunction Fonction à associer
                 */
                SetCallback: function (pFunction) {
                    this.aCallback[this.GetCurrentTabID()] = pFunction;
                },
                GetCallback: function () {
                    if (this.aCallback[this.GetCurrentTabID()]) {
                        this.aCallback[this.GetCurrentTabID()]();
                    }
                },
                /**
                 * Associer un texte à un onglet
                 * @param pLabel Texte à afficher
                 */
                SetText: function (pLabel) {
                    var textToDecode = parameter.decodeParam(pLabel);
                    this.GetCurrentTab().find("a").text(textToDecode);
                },
                /**
                 * Recharger un onglet
                 */
                Reload: function () {
                    this.GetCallback();
                },
                SetExpanded: function (ExpandedID) {
                    this.aExpanded[this.GetCurrentTabID()] = ExpandedID;
                },
                GetExpanded: function () {
                    return this.GetFrame()
                            .find("#" + this.aExpanded[this.GetCurrentTabID()]);
                },
                SetFocused: function (FocusedID) {
                    this.aFocused[this.GetCurrentTabID()] = FocusedID;
                },
                GetFocused: function () {
                    return this.GetFrame()
                            .find("#" + this.aFocused[this.GetCurrentTabID()]);
                },
                SetOffset: function (Offset) {
                    this.aOffset[this.GetCurrentTabID()] = Offset;
                },
                GetOffset: function () {
                    return this.aOffset[this.GetCurrentTabID()];
                },
                SetScroll: function (ScrollTop) {
                    this.aScroll[this.GetCurrentTabID()] = ScrollTop;
                },
                GetScroll: function () {
                    return this.aScroll[this.GetCurrentTabID()];
                },
                SetOrder: function (OrderBy) {
                    this.aOrder[this.GetCurrentTabID()] = OrderBy;
                },
                GetOrder: function () {
                    if (!this.aOrder[this.GetCurrentTabID()]) {
                        return "";
                    }
                    return this.aOrder[this.GetCurrentTabID()];
                },
                /**
                 * Obtenir l'onglet père
                 * @returns L'onglet père
                 */
                GetParent: function () {
                    return this.aParent[this.GetCurrentTabID()];
                },
                /**
                 * Obtenir un tableau d'onglet fils
                 * @returns Tableau d'onglet fils
                 */
                GetChild: function () {
                    return this.aChild[this.GetCurrentTabID()];
                },
                /**
                 * Supprimer les onglets enfants d'un Onglet père
                 * @param TabID Identifiant de l'onglet père
                 */
                RemoveChildren: function (TabID) {
                    if (this.aChild[TabID]) {
                        var Children = this.aChild[TabID].slice(0);
                        // Tableau d'onglet enfants
                        if (Children) {
                            // Supprimer tous les enfants des enfants
                            Children.forEach(function (Child) {
                                var id = $(Child).attr("id");
                                Seed.Tab.RemoveChildren(id);
                                Seed.Tab.RemoveNode(id);
                            });
                            delete this.aChild[TabID];
                        }
                    }
                },
                /**
                 * Montrer les onglets enfants  (classe => couleur)
                 */
                ShowChildren: function () {
                    var children = this.GetChild();
                    if (children) {
                        children.forEach(function (Child) {
                            $(Child).find("a").addClass("Seed_Tab_Child");
                        });
                    }
                },
                /**
                 * Montrer l'onglet parent (classe => couleur)
                 */
                ShowParent: function () {
                    var parent = this.GetParent();
                    if (parent) {
                        parent.find("a").addClass("Seed_Tab_Parent");
                    }
                },
                /**
                 * Montrer l'onglet actuel (classe => couleur)
                 */
                ShowActive: function () {
                    this.GetCurrentTab().find("a").addClass("Seed_Tab_Active");
                },
                /**
                 * Supprimer les styles des onglets
                 */
                ClearStyle: function () {
                    $(".Seed_Tab_Active").removeClass("Seed_Tab_Active");
                    $(".Seed_Tab_Parent").removeClass("Seed_Tab_Parent");
                    $(".Seed_Tab_Child").removeClass("Seed_Tab_Child");
                },
                /**
                 * Obtient le corps lié à l'onget courant
                 */
                GetFrame: function () {
                    return $("#tab_" + this.GetCurrentTabID());
                },
                /**
                 * Ajouter un onglet
                 */
                AddTab: function () {
                    this.ClearStyle();
                    if (this.GetCurrentTab()) {
                        if ((this.aModule[this.GetCurrentTabID()]) === this.CurrentModule) {
                            // SET CURRENT AS PARENT
                            this.aParent[this.iTab] = this.GetCurrentTab();
                            this.aParent[this.iTab].find("a").addClass("Seed_Tab_Parent");
                        }
                    }

                    this.cTab = $("<li></li>");
                    this.cTab.attr("id", this.iTab);
                    if (this.GetParent()) {
                        // SET NEW TAB AS CHILD OF PARENT
                        if (!this.aChild[this.GetParent().attr("id")]) {
                            this.aChild[this.GetParent().attr("id")] = new Array();
                        }
                        this.aChild[this.GetParent().attr("id")].push(this.cTab);
                    }

                    var Link = $("<a class='Seed_Tab Seed_Tab_Active' id='link_"
                            + this.iTab + "'></a>");
                    // Click : refresh des onglets (changement d'onglet ou reclik)
                    Link.click(function (event) {
                        if (event.button !== 1) {
                            linkClick(this, false);
                        }
                    });
                    this.cTab.append(Link);
                    // Ajout d'un bouton Close si le Module contient déjà un onglet
                    if (this.aActive[this.CurrentModule] !== null) {
                        var Close = $('<div class="Seed_Tab_Close" href="javascript:">X</div>');
                        // Fermeture de l'onglet : Suppression d'éléments
                        this.cTab.mouseup(function (event) {
                            if (event.button === 1) {
                                Seed.Tab.Close($(this).attr("id"));
                                return false;
                            }
                        });
                        Close.click(function () {
                            Seed.Tab.Close($(this).parent().attr("id"));
                        });
                        //Link.append(Close);
                        this.cTab.append(Close);
                    }
                    // Association de l'onglet avec le Module
                    this.aModule[this.iTab] = this.CurrentModule;
                    this.aActive[this.CurrentModule] = this.iTab;
                    // Ajout de l'onget à l'affichage
                    $("#" + this.CurrentModule + "_tab").append(this.cTab);
                    // Construction du contenu
                    var TabContent = $("<div id='tab_" + this.iTab + "'> </div>");
                    // Cacher tous les contenus lié au Module
                    $("#" + this.CurrentModule + "_content")
                            .find(".tab_content").hide();
                    // Ajouter le nouveau contenu
                    $("#" + this.CurrentModule + "_content").append(TabContent);
                    // Désigner ce contenu comme contenu
                    TabContent.addClass('tab_content');
                    // Incrément du compteur général
                    this.iTab++;
                },
                /**
                 * Afficher le module demandé
                 * @param {string} pModuleName Nom du module
                 * @param {string} pTitre Titre de l'onglet
                 */
                ShowModule: function (pModuleName, pTitre, isDefaultAction) {
                    // On cache le module courant s'il existe
                    if (this.CurrentModule !== 0) {
                        $("#" + this.CurrentModule + "_frame").hide();
                    }
                    if (isDefaultAction !== true
                            && pModuleName !== "accueil") {
                        Seed.Menu.Clear(pModuleName);
                    }

                    // Creation pModuleName_frame
                    if ($("#" + pModuleName + "_frame").length === 0) {
                        var frame = $("<div></div>");
                        frame.attr("id", pModuleName + "_frame");
                        $("#tdcontent").append(frame);
                        var rowOnglet = $("<ul></ul>");
                        rowOnglet.attr("id", pModuleName + "_tab");
                        rowOnglet.attr('class', 'nav nav-pills ongletModule navbar-fixed-top');
                        frame.append(rowOnglet);
                        var content = $("<div></div>");
                        content.attr('id', pModuleName + '_content');
                        content.attr('class', 'tab-pane fade active in container-fluid the-content');
                        frame.append(content);
                    } else {
                        this.cTab = $("#" + this.aActive[pModuleName]);
                        this.ClearStyle();
                        this.ShowActive();
                        this.ShowParent();
                        this.ShowChildren();
                        this.Reload();
                    }
                    // On affiche le nouveau module
                    $("#" + pModuleName + "_frame").fadeIn("slow");
                    // Module courant = Module
                    this.CurrentModule = pModuleName;
                    resizeScreen.resizeScreen();
                },
                /**
                 * Recherche d'un noeud par identifiant et par nom
                 * @param {int} pId Identifiant
                 * @param {string} pNodeName Nom
                 */
                SearchNode: function (pId, pNodeName) {
                    if (document.getElementById("tab_" + this.GetCurrentTabID()) == null) {
                        debugger;
                    }
                    var divlist = document.getElementById("tab_" + this.GetCurrentTabID())
                            .getElementsByTagName(pNodeName);
                    var length = divlist.length;
                    for (var i = 0; i < length; i++) {
                        if (divlist[i].id === pId) {
                            return divlist[i];
                        }
                    }
                    return null;
                },
                RemoveNode: function (idTab) {
                    var Parent = this.aParent[idTab];
                    $("#tab_" + idTab).remove();
                    $('li#' + idTab).remove();
                    delete this.aCallback[idTab];
                    delete this.aModule[idTab];
                    delete this.aParent[idTab];
                    if (typeof Parent != "undefined") {
                        var idParent = Parent.attr("id");
                        var Children = this.aChild[idParent];
                        if (Children) {
                            // Supprimer tous les enfants des enfants
                            var count = Children.length;
                            for (var i = 0; i < count; i++) {
                                var Child = Children[i];
                                if (Child) {
                                    var idChild = Child.attr("id");
                                    if (idChild === idTab) {
                                        //                            delete Child;
                                        this.aChild[idParent].splice(i, 1);
                                    }
                                }
                            }
                        }
                        if (this.aChild[idParent].length === 0) {
                            delete this.aChild[idParent];
                        }
                    } else {
                        Children = "undefined";
                    }
                },
                Close: function (idTab) {
                    if (typeof idTab === "undefined") {
                        // onglet courant
                        var CurrentTab = this.GetCurrentTab();
                        idTab = CurrentTab.attr("id");
                    }

                    if (!requiredField.checkRequiredFields(idTab)) {
                        return false;
                    }

                    // Suppression des onglets enfants
                    Seed.Tab.RemoveChildren(idTab);
                    // Onglet parent
                    var Parent = this.aParent[idTab];
                    // Onglet courant = onglet père
                    var newCTab;
                    if (this.GetCurrentTabID() === idTab) {
                        this.cTab = Parent;
                    } else {
                        newCTab = Parent;
                    }

                    // Menage
                    if (typeof kendo !== "undefined") {
                        destroyGrid(idTab);
                    }
                    this.RemoveNode(idTab);
                    // Verification du CurrentTab
                    var idCurrent = this.GetCurrentTabID();
                    if ($("#tab_" + idCurrent).length === 0) {
                        this.cTab = Parent;
                    }

                    // Style
                    this.ClearStyle();
                    this.ShowActive();
                    this.ShowParent();
                    this.ShowChildren();
                    $("#tab_" + this.GetCurrentTabID()).show();
                    this.Reload();
                },
                CheckArrays: function () {
                    var result = true;
                    // aParent
                    var count = this.aParent.length;
                    for (var i = 0; i < count; i++) {
                        var elem = this.aParent[i];
                        if (elem) {
                            if ($('[id^=link_' + i + ']').length === 0) {
                                result = false;
                                console.log('Check NOK : aParent index : ' + i);
                            }

                            var id = $(elem).attr('id');
                            if ($('[id^=link_' + id + ']').length === 0) {
                                result = false;
                                console.log('Check NOK : aParent contenu :' + i + ', ' + id);
                            }
                        }
                    }

                    // aCallback
                    var count = this.aCallback.length;
                    for (var i = 0; i < count; i++) {
                        elem = this.aCallback[i];
                        if (elem) {
                            if ($('[id^=link_' + i + ']').length === 0) {
                                result = false;
                                console.log('Check NOK : aCallback index : ' + i);
                            }
                        }
                    }

                    // aChild
                    var count = this.aChild.length;
                    for (var i = 0; i < count; i++) {
                        elem = this.aChild[i];
                        if (elem) {
                            if ($('[id^=link_' + i + ']').length === 0) {
                                result = false;
                                console.log('Check NOK : aChild index : ' + i);
                            }

                            var nbChild = elem.length;
                            for (var j = 0; j < nbChild; j++) {
                                var child = elem[j];
                                if (child) {
                                    var id = $(child).attr('id');
                                    if ($('[id^=link_' + id + ']').length === 0) {
                                        result = false;
                                        console.log('Check NOK : aChild contenu : ' + i + ', ' + id);
                                    }
                                }
                            }
                        }
                    }

                    var link = $('[id^=link_]');
                    var count = link.length;
                    for (var i = 0; i < count; i++) {
                        var id = $(link[i]).attr('id').substring(1, -1);
                        // aCallback
                        if (typeof this.aCallback[id] === "undefined") {
                            console.log('Check NOK : aCallback existe pas : ' + id);
                        }
                        // aParent
                        if (typeof this.aParent[id] === "undefined") {
                            console.log('Check NOK : aParent existe pas : ' + id);
                        }
                    }

                    return result;
                },
                /**
                 * Affiche ou cache des element de la page selon les valeurs
                 */
                SetVisibility: function () {
                    var elements = Seed.Tab.GetFrame().find('[data-visible]')
                            .toArray();
                    var count = elements.length;
                    for (var i = 0; i < count; i++) {
                        var elem = elements[i];
                        var condition = $(elem).attr('data-visible');
                        var isFound = (condition.indexOf('$_VAL[') !== -1);
                        if (isFound) {
                            condition = condition.replace(']', ']").val()');
                            condition = condition.replace('$_VAL[', 'Seed.Tab.GetFrame().find("[id^=');
                            var result = eval(condition);
                            if (result) {
                                $(elem).show();
                            } else {
                                $(elem).hide();
                            }
                        } else {
                            if (eval(condition)) {
                                $(elem).show();
                            } else {
                                $(elem).hide();
                            }
                        }
                    }
                }
            };
            function linkClick(elem, noReload)
            {
                var tempId = Seed.Tab.GetCurrentTabID();
                var tempOffset = 0;
                Seed.Tab.cTab = $(elem).parent();
                Seed.Tab.ClearStyle();
                Seed.Tab.ShowActive();
                Seed.Tab.ShowParent();
                Seed.Tab.ShowChildren();
                Seed.Tab.aActive[Seed.Tab.CurrentModule] = Seed.Tab.cTab.attr("id");
                if (typeof Seed.Tab.GetOffset() !== 'undefined'
                        || Seed.Tab.GetOffset() >= 0) {
                    var clickedTabId = Seed.Tab.GetCurrentTabID();
                    if (tempId === clickedTabId) {
                        tempOffset = Seed.Tab.SetOffset(Seed.Tab.GetOffset() - 1);
                    } else {
                        tempOffset = Seed.Tab.SetOffset(Seed.Tab.GetOffset());
                    }
                }
                $("#" + Seed.Tab.CurrentModule + "_content")
                        .find(".tab_content").hide();
                $("#tab_" + Seed.Tab.cTab.attr("id")).show();
                if (noReload) {
                    return true;
                }
                Seed.Tab.Reload();
                Seed.Tab.GetElementInFrame(tempOffset);
                Seed.Tab.GetFrame().find('[id^=listSearch]').show();
            }
        }
);
